// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'acuminproBoldWebfont', 'acuminproBoldWebfont Fallback'"},"className":"__className_7375e8","variable":"__variable_7375e8"};